module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Icon/social/new/facebook-b393d7e30c64882f7e1dc7552c46f44d.svg";